import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { MOB_EVENT_TYPE_PAGE_VIEW } from '../config/const';
import { mob } from '../utils/logger';

export default function RouteChangeTracker() {
  const location = useLocation();
  const lastPathRef = useRef('');

  useEffect(() => {
    const routePathname = location.pathname || '';
    if (routePathname === lastPathRef.current) return;
    lastPathRef.current = routePathname;

    // route 去除开头斜杠，仅上报形如 "pricing/a"
    const route = routePathname.startsWith('/') ? routePathname.slice(1) : routePathname;

    // 解析 query 参数
    const toObj = (params) => {
      const obj = {};
      if (!params) return obj;
      for (const [k, v] of params.entries()) obj[k] = v;
      return obj;
    };

    const win = typeof window !== 'undefined' ? window : undefined;
    const searchParams = win ? new URLSearchParams(win.location.search || '') : undefined;

    // 解析 hash: "#resp?param1=a&param2=b" => hashPath: "resp"，hashParams: { param1, param2 }
    let hashPath = undefined;
    let hashParams = undefined;
    if (win && typeof win.location.hash === 'string' && win.location.hash) {
      let h = win.location.hash;
      if (h.startsWith('#')) h = h.slice(1);
      const idx = h.indexOf('?');
      if (idx >= 0) {
        hashPath = h.slice(0, idx) || undefined;
        const q = h.slice(idx + 1);
        hashParams = new URLSearchParams(q);
      } else {
        hashPath = h || undefined;
      }
    }

    mob('memu_pro_page_view',
      MOB_EVENT_TYPE_PAGE_VIEW,
      {
        route,
        title: typeof document !== 'undefined' ? document.title : undefined,
        referrer: typeof document !== 'undefined' ? document.referrer : undefined,
        // 展平 query/hash 参数
        search_params: toObj(searchParams),
        hash_params: toObj(hashParams),
        // 附带 hash 的路径段
        hash_path: hashPath,
      });

  }, [location]);

  return null;
}


